import { render, staticRenderFns } from "./PhaseDocumentUploader.vue?vue&type=template&id=f0577a3e&scoped=true&"
import script from "./PhaseDocumentUploader.vue?vue&type=script&lang=js&"
export * from "./PhaseDocumentUploader.vue?vue&type=script&lang=js&"
import style0 from "./PhaseDocumentUploader.vue?vue&type=style&index=0&id=f0577a3e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0577a3e",
  null
  
)

export default component.exports